<div class="big-card-header">
  <div class="icon-square"><mat-icon>group</mat-icon></div>
  <div class="big-card-title">
    <div class="title-line">
      <div class="name">{{ name }}</div>
      <button *ngIf="canEdit" mat-icon-button class="pencil" (click)="edit.emit()" aria-label="Edit team">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
    <div class="meta-line">
      <span *ngIf="membersCount !== null">{{ membersCount }} members</span>
      <span *ngIf="membersCount !== null" aria-hidden="true">•</span>
      <span><strong>{{ amount | currency:'USD':'symbol':'1.0-2' }}</strong> /month per employee</span>
      <button *ngIf="canEdit" mat-icon-button class="pencil" (click)="edit.emit()" aria-label="Edit benefit amount">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>
</div>
